import ProductTabMain from './main/product-tab-main';
import ProductTabProperties from './properties';
import ProductTabReviews from './reviews';
import ProductTabStatistics from './statistics';

export {
  ProductTabProperties,
  ProductTabReviews,
  ProductTabMain,
  ProductTabStatistics,
};
